import { IApplicable } from '../../shared/models/applicable';
import { IBookmarkable } from '../../shared/models/bookmarkable';
import { environment } from '../../../environments/environment';
import { IParseable } from '../../shared/models/IParseable';

export class JobSummary implements IBookmarkable, IApplicable, IParseable {
    constructor() {}
    public id: string;
    public title: string;
    public description: string;
    public expiry: string;
    public sector: string;
    public salaryType: string;
    public type: string;
    public salaryRange: string;
    public location: string;
    public city: string;
    public country: string;
    public bookmarked: boolean;
    public applied: boolean = false;
    public applicationDate: Date;
    public businessLogo: string;
    public postedBy: string;
    public jobPosterAddress: string;
    public totalAmountSpent: number;

    parse(json: any): JobSummary {
        let jobSummary = new JobSummary();
        Object.assign(jobSummary, json);
        if(jobSummary.businessLogo)
            jobSummary.businessLogo = `${environment.baseUrl}/${jobSummary.businessLogo}`;
        return jobSummary;
    }

    public static parse(json): JobSummary {
        let jobSummary = new JobSummary();
        return jobSummary.parse(json);;
    }
}

